module.exports = __webpack_public_path__ + "img/2.0c8ceef0.png";